import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import InterventionsTable from "@/components/ListTable/InterventionsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { INTERVENTIONS_INCLUDES } from "@/entities/interventions";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import InterventionAddButton from "@/modules/intervention/intervention-add-button";
import { ListProvider } from "@/modules/list";

const Interventions = () => {
  const { t } = useTranslation();

  const InterventionIncludes = [
    INTERVENTIONS_INCLUDES.USERS,
    INTERVENTIONS_INCLUDES.TEMPLATE,
  ];

  return (
    <>
      <BaseHeader title={t("navigation:interventions")} />
      <AppLayoutPage>
        <ListProvider
          endpoint="interventions"
          storageKey={STORAGE_KEYS.INTERVENTIONS}
          includes={InterventionIncludes}
          withContext
        >
          <InterventionsTable
            showLocationColumn
            showAssetColumn
            extraActions={<InterventionAddButton />}
          />
        </ListProvider>
      </AppLayoutPage>
    </>
  );
};

export default Interventions;
